import React, { FunctionComponent, ReactNode } from 'react'
import styles from './SidePanel.module.sass'
import clsx from 'clsx'
import { Portal } from 'react-portal'
import Button, { ButtonStyle, Shape, Size } from '../../controls/Button/Button'
import { motion } from 'framer-motion'
import Aside from '../Aside/Aside'
import { useUpdateEffect } from 'react-use'
import { useLocation } from 'react-router'
import CloseIcon from 'files/close.svg'
import ChevronRightIcon from 'files/chevron/right.svg'
import { useRootSelector } from '../../../utils/hooks'
import { useQueries } from '../../../utils/hooks/useQueries'
import { Colors } from '../../../styles'

interface Props {
    className?: string,
    header?: ReactNode,
    zIndex?: number,
    onClose: () => void,
}

const SidePanel: FunctionComponent<Props> = props => {
    const { pathname } = useLocation()
    const width = useRootSelector(state => state.global.system.asideRatio * window.innerWidth)
    useUpdateEffect(props.onClose, [pathname])
    const {isMobile} = useQueries()

    return <Portal>
        <motion.div
            className={styles.sidePanel}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{ zIndex: props.zIndex }}
            onClick={event => event.target == event.currentTarget && props.onClose?.()}
        >
            <motion.div
                initial={{ right: -width }}
                animate={{ right: 0 }}
                exit={{ right: -width }}
                className={styles.animationWrapper}
            >
                <Aside className={styles.panel}>
                    <div className={styles.header}>
                        {props.header}
                        <Button
                            className={styles.button}
                            size={Size.HUGE}
                            buttonShape={Shape.ROUND}
                            color={Colors.red}
                            buttonStyle={ButtonStyle.TINTED}
                            onClick={props.onClose}
                        >
                            {
                                isMobile? <ChevronRightIcon/>: <CloseIcon/>
                            }
                        </Button>
                    </div>
                    <div className={clsx(props.className, styles.body)}>
                        {props.children}
                    </div>
                </Aside>
            </motion.div>
        </motion.div>
    </Portal>
}

export default SidePanel